import { render } from "./ProductListComponent.vue?vue&type=template&id=2933d9e7"
import script from "./ProductListComponent.vue?vue&type=script&lang=js"
export * from "./ProductListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__